let lastScrollTop = 0;

window.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("keyup", keyPress);
  if (!document.documentElement.classList.contains('sticky')){window.addEventListener("scroll", scrolling);}
  notifications();
  manage_return_to();
  [...document.querySelectorAll('form.c-ContactForm-form input.border.w-full')].forEach(input=>{
    if (input.value != ''){input.nextElementSibling.classList.add('!-top-8', '!left-0');}
    input.onblur=()=>{
      if (input.value == ''){
        input.nextElementSibling.classList.remove('!-top-8', '!left-0');
      } else {
        input.nextElementSibling.classList.add('!-top-8', '!left-0');
      }
    }
  });
})

function manage_return_to() {
  const loginForm = document.querySelector('#customer_login')
  if (loginForm) {
    const urlParams = new URLSearchParams(window.location.search)
    const returnTo = urlParams.get('return_to')
    if(returnTo) {
      const returnToInput = document.createElement('input')
      returnToInput.type = 'hidden'
      returnToInput.name = 'return_to'
      returnToInput.value = returnTo
      loginForm.appendChild(returnToInput)
    }
  }
}

function addToCart(e) {
  e.preventDefault()

  e.target.querySelector('[type="submit"]').disabled = true
  // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
  // Gestion dynamique des propriétés (properties[])

  let formData = Object.fromEntries(new FormData(e.target))
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key]; // On enlève la propriété brute du formData
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description || data.message;
      if (erreurs) {
        addToCartErrors(erreurs, e.target);
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        hideAddToCartErrors(e.target);
      }
      // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
      updateCart(data);
      if (window.location.href.includes('/collections/') && document.querySelector('button.open-cart-link>span')){
        //document.querySelector('div#atcpopup>p>span').innerText = data.title;
        document.querySelector('div#atcpopup').style.bottom = 0;
        document.querySelector('div#atcpopup').style.opacity = 1;
        setTimeout(()=>{document.querySelector('div#atcpopup').removeAttribute('style');},5000);
      } else {
        document.documentElement.classList.add("cart-drawer");
      }
      e.target.querySelector('[type="submit"]').disabled = false;
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function addToCartErrors(message, form) {
  if (form.querySelector('.product_errors')){
    form.querySelector('.product_errors').classList.remove("hidden");
    form.querySelector('.product_errors_message').textContent = message;
  }
  return false;
}
function hideAddToCartErrors(form) {
  if (form.querySelector('.product_errors')){form.querySelector('.product_errors').classList.add("hidden");}
}

async function checkEmptyCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    if (cart.item_count > 0) {
      document.querySelector(".product_errors-coffret").classList.remove("hidden")
      document.querySelector(".product_errors-coffret .product_errors_message").textContent = "Votre panier contient déjà d’autres articles. Veuillez le vider afin de pouvoir souscrire à un abonnement."
      document.querySelector(".product_errors-coffret + a").classList.add('opacity-30')
      document.querySelector(".product_errors-coffret + a").classList.add('pointer-events-none')
    } else {
      document.querySelector(".product_errors-coffret").classList.add("hidden")
      document.querySelector(".product_errors-coffret + a").classList.remove('opacity-30')
      document.querySelector(".product_errors-coffret + a").classList.remove('pointer-events-none')
      window.location = e.target.href;
    }
  } catch (error) {
    console.error("Erreur:", error);
  }
}

function addToCartOffrir(e) {
  e.preventDefault()
  e.target.querySelector('[type="submit"]').disabled = true

  let formData = Object.fromEntries(new FormData(e.target));
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key]; // On enlève la propriété brute du formData
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      const erreurs = data.errors || data.description || data.message;
      if (erreurs) {
        e.target.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden");
        e.target.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        e.target.parentNode
          .querySelector(".product_errors")
          .classList.add("hidden");
        updateCart(data);
        window.location.href = "/checkout";
        e.target.querySelector('[type="submit"]').disabled = false;
      }
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function keyPress(e) {
  if (e.code == "Escape") {
    if (document.querySelector("html.cart-drawer")) document.documentElement.classList.remove("cart-drawer")
  }
}

function scrolling(e) {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  window.pageYOffset > 100 && scrollTop > lastScrollTop
    ? document.documentElement.classList.add("scroll-down")
    : document.documentElement.classList.remove("scroll-down");
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

function toggleFilters(e) {
  document.querySelectorAll(".hidden-tag").forEach((el) => {
    el.classList.toggle("hidden");
  })
  if (document.querySelector(".filters-toogle").innerText == "Voir moins")
    document.querySelector(".filters-toogle").innerText = "Voir tout";
  else document.querySelector(".filters-toogle").innerText = "Voir moins";
}

function plusQuantity(e, maxStock) {
  e.parentNode.querySelector('[onclick^="minQuantity"]').classList.remove('off')
  var currentValue = e.parentNode.querySelector("input").value
  if (currentValue >= maxStock) return
  currentValue++
  e.parentNode.querySelector("input").value = currentValue
  if (currentValue >= maxStock){
    if (e.parentNode.querySelector('[onclick^="plusQuantity"]')){
      e.parentNode.querySelector('[onclick^="plusQuantity"]').classList.add('off');
    } else {
      e.parentNode.querySelector('[onclick="cartIncreaseQty(this)"]').classList.add('off');
    }
  }
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value
  if (currentValue == 1) return
  currentValue--
  if (currentValue == 1) e.parentNode.querySelector('[onclick^="minQuantity"]').classList.add('off')
  e.parentNode.querySelector("input").value = currentValue;
  console.log(e.parentNode);
  if (e.parentNode.querySelector('[onclick^="plusQuantity"]')){
    e.parentNode.querySelector('[onclick^="plusQuantity"]').classList.remove('off');
  } else {
    e.parentNode.querySelector('[onclick="cartIncreaseQty(this)"]').classList.remove('off');
  }
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink()
}

function fetchCartUpdateQty(el, itemId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
  .then((response) => response.json()).then((data) => {
    if (data.status != 422) {
      window.updateCart();
      if (quantity === 0) el.closest(".cartDrawer_item").remove();
    } else {
      console.error("Impossible de mettre à jour le cart");
      el.value = el.getAttribute('data-cart-quantity');
      addToCartErrors(data.message, el.closest('article'));
    }
    document.querySelector("#cart-drawer")?.classList.remove("loading");
  })
  .catch((error) => console.error("Erreur :", error));
}

window.cartUpdateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(el.parentNode.querySelector("[name='quantity']").value)
  fetchCartUpdateQty(el, itemId, quantity) 
  return false
}

window.cartReduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;
  fetchCartUpdateQty(el, itemId, quantity)
  return false
};

window.cartIncreaseQty = (el) => {
  
  const maxStock = parseInt(el.getAttribute('max'))
  if(maxStock<=0) return

  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  let quantity = parseInt(el.parentNode.querySelector("[name='quantity']").value)
  quantity++

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description || data.message;
      if (erreurs) {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden")
        el.parentNode.parentNode.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
}

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  fetchCartUpdateQty(el, itemId, 0);
  return false
};

window.emptyCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Panier vidé avec succès", data);
    })
    .catch((error) => {
      console.error("Erreur emptyCart :", error);
    });
};

function notifications() {
  document.querySelectorAll("[data-customer-tag]").forEach((el) => {
    el.addEventListener("click", () => {
      customerTags(el.dataset.customer, el.getAttribute("data-tag-to-remove"), el.getAttribute("data-tag-to-add"), el, el.getAttribute('data-obsolete-email'), el.getAttribute('data-id'));
    });
  });
}

function customerTags(customerId, tag_to_remove, tag_to_add, el, email, vid) {
  if (customerId == "") return;
  let messageDiv = el.parentNode.querySelector(".message-etre-prevenu");
  if (!messageDiv){messageDiv = el.parentNode.parentNode.querySelector(".message-etre-prevenu");}
  if (tag_to_remove == "") {
    el.classList.add("on"); messageDiv.classList.remove("hidden");
  } else {
    el.classList.remove("on"); messageDiv.classList.add("hidden");
  }
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const raw = JSON.stringify({user_id: customerId, tags_to_remove: [tag_to_remove], tags_to_add: [tag_to_add] });
  const requestOptions = {method: "POST", headers: myHeaders, body: raw, redirect: "follow", mode: "no-cors"};
  fetch("https://cdo-customertags.thisispam.workers.dev", requestOptions).then((response)=>response.text()).then((result)=>console.log(result))
    .catch((error) => console.error(error)).then(()=>{
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Vx3bcq', {
        method: 'POST',
        headers: {"Content-Type": "application/json", "revision":"2024-06-15", "Access-Control-Allow-Origin": "https://www.chaisdoeuvre.fr"},
        credentials: 'omit',
        body: JSON.stringify({"data": {
          "type": "back-in-stock-subscription",
          "attributes": {"profile": {"data": {"type": "profile", "attributes": {"email": `${email}`}}}, "channels": ["EMAIL"]},
          "relationships": {"variant": {"data": {"type": "catalog-variant", "id": `$shopify:::$default:::${vid}`}}}
        }})
      });
    });
}
class restock extends HTMLElement {
  constructor(){super();}
  connectedCallback() {
    this.onclick=()=>{
      if (this.dataset.customer == ''){return};
      let messageDiv = this.parentNode.querySelector('div.message-etre-prevenu');
      if (!messageDiv){messageDiv = this.parentNode.parentNode.querySelector('div.message-etre-prevenu');}
      if (this.getAttribute("data-tag-to-remove") == '') {
        this.classList.add("on"); messageDiv.classList.remove("hidden");
      } else {
        this.classList.remove("on"); messageDiv.classList.add("hidden");
      }
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify({user_id: this.dataset.customer, tags_to_remove: [this.getAttribute("data-tag-to-remove")], tags_to_add: [this.getAttribute("data-tag-to-add")] });
      const requestOptions = {method: "POST", headers: myHeaders, body: raw, redirect: "follow", mode: "no-cors"};
      fetch("https://cdo-customertags.thisispam.workers.dev", requestOptions).then((response)=>response.text()).then((result)=>console.log(result))
        .catch((error) => console.error(error)).then(()=>{
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Vx3bcq', {
            method: 'POST',
            headers: {"Content-Type": "application/json", "revision":"2024-06-15", "Access-Control-Allow-Origin": "https://www.chaisdoeuvre.fr"},
            credentials: 'omit',
            body: JSON.stringify({"data": {
              "type": "back-in-stock-subscription",
              "attributes": {"profile": {"data": {"type": "profile", "attributes": {"email": `${this.getAttribute('data-obsolete-email')}`}}}, "channels": ["EMAIL"]},
              "relationships": {"variant": {"data": {"type": "catalog-variant", "id": `$shopify:::$default:::${this.getAttribute('data-id')}`}}}
            }})
          });
        });
    }
  }
}
customElements.define('re-stock', restock);
function sendActivationCustomerLink(e) {

  e.preventDefault()

  const email = document.querySelector('#form-activation [name="email"]').value

  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  const raw = JSON.stringify({
    "email": email
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    mode: "no-cors",
  };

  fetch("https://cdo-send-account-activation-link.thisispam.workers.dev", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      document.querySelector('#activate-account-success').classList.remove('hidden')
      document.querySelector('#form-activation').classList.add('hidden')
      console.log(result)
    })
    .catch((error) => console.error(error));
}

function updateCustomerDetails(e) {
  e.preventDefault();
  if (e.target.querySelector("[name='user_id']").value == "") return;

  const user_id = e.target.querySelector("[name='user_id']").value;
  const genre = e.target.querySelector("[name='genre']:checked").value;
  const first_name = e.target.querySelector("[name='first_name']").value;
  const last_name = e.target.querySelector("[name='last_name']").value;
  const birth_date = e.target.querySelector("[name='birth_date']").value;
  const phone = e.target.querySelector("[name='phone']").value;

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = {
    user_id: user_id,
    first_name: first_name,
    last_name: last_name,
    phone: phone,
  };

  raw = JSON.stringify(raw);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    mode: "no-cors",
  };

  fetch(
    "https://chaisdoeuvre-pam-shopify-customer-details.thisispam.workers.dev",
    requestOptions,
  )
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));

  // worker metafield
  setAccountMetafield(user_id, "facts", "birth_date", birth_date, "update");
  setAccountMetafield(user_id, "custom", "genre", genre, "update");

  document.querySelector(".adresseUpdate_message").classList.remove("hidden");
}

function setAccountMetafield(
  customerId,
  namespace,
  metafield,
  valeurs,
  action,
) {
  if (customerId == "") return;

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    user_id: customerId,
    namespace: namespace,
    key: metafield,
    value: valeurs,
    action: action,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    mode: "no-cors",
  };

  fetch("https://cdo-customfields.thisispam.workers.dev", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}

function updateAccountPreferences(e) {
  e.preventDefault();
  setAccountMetafield(
    e.target.dataset.customer,
    "custom",
    "categories",
    Array.from(
      document.querySelectorAll('[name^="categorie"]:not(:checked)'),
    ).map((el) => el.value),
    "remove",
  );
  setAccountMetafield(
    e.target.dataset.customer,
    "custom",
    "categories",
    Array.from(document.querySelectorAll('[name^="categorie"]:checked')).map(
      (el) => el.value,
    ),
    "add",
  );
  setAccountMetafield(
    e.target.dataset.customer,
    "custom",
    "regions_favorites",
    Array.from(document.querySelectorAll('[name^="region"]:not(:checked)')).map(
      (el) => el.value,
    ),
    "remove",
  );
  setAccountMetafield(
    e.target.dataset.customer,
    "custom",
    "regions_favorites",
    Array.from(document.querySelectorAll('[name^="region"]:checked')).map(
      (el) => el.value,
    ),
    "add",
  );
}

// action remove or add
function wishlist(event, user_id, product_id) {
  let action = "add";
  if (event.dataset.inwishlist == "true") {
    event.classList.remove("on");
    action = "remove";
    event.dataset.inwishlist = "false";
  } else {
    event.classList.add("on");
    action = "add";
    event.dataset.inwishlist = "true";
  }

  if (user_id == "") return;
  if (product_id == "") return;

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    user_id: user_id,
    product_id: product_id,
    action: action,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    mode: "no-cors",
  };

  fetch("https://cdo-wishlist.thisispam.workers.dev", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}

function loadLikeBuyPopupProductInfo(handle) {
  
  if(document.querySelector('#popup-card-large .card-product-large_closeWrap')) document.querySelector('#popup-card-large .card-product-large_closeWrap').scroll(0,0)
  
  fetch('/products/'+handle)
    .then(response => {
      if (!response.ok) throw new Error(`Erreur lors de la récupération : ${response.status}`)
      return response.text()
    })
    .then(html => {

      document.querySelector('#popup-card-large').setAttribute('aria-hidden', false);

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const jAimeElement = doc.querySelector('#j_aime')
      const jAcheteElement = doc.querySelector('#jachete')
      const productTitleElement = doc.querySelector('#pop-productTitle')
      const domaineElement = doc.querySelector('#pop-domaine')
      const millesimeElement = doc.querySelector('#pop-millesime')
      const imgElement = doc.querySelector('#pop-img')

      document.querySelector('#popup-card-large-title').innerHTML = ''
      document.querySelector('#popup-card-large-domaine').innerHTML = ''
      document.querySelector('#popup-card-large-millesime').innerHTML = ''
      document.querySelector('#popup-card-large-jaime .wysiwyg').innerHTML = ''
      document.querySelector('#popup-card-large-jachete .wysiwyg').innerHTML = ''
      document.querySelector('#popup-card-large-img').setAttribute('src', '')
      if(imgElement.textContent)document.querySelector('#popup-card-large-img').setAttribute('src', imgElement.textContent)


      if (productTitleElement) document.querySelector('#popup-card-large-title').innerHTML = productTitleElement.textContent.trim()
      if (domaineElement) document.querySelector('#popup-card-large-domaine').innerHTML = domaineElement.textContent.trim()
      if (millesimeElement) document.querySelector('#popup-card-large-millesime').append(millesimeElement.textContent.trim())
      if (jAimeElement) document.querySelector('#popup-card-large-jaime .wysiwyg').innerHTML = jAimeElement.innerHTML.trim()
      if (jAcheteElement) document.querySelector('#popup-card-large-jachete .wysiwyg').innerHTML = jAcheteElement.innerHTML.trim()
    })
    .catch(error => {
      console.error('Erreur :', error)
    })
}
document.querySelector('button.burger').onclick = function(e){
  e.preventDefault();
  document.documentElement.classList.toggle('nav-on');
  //window.scrollTo(0, 36);
  this.nextElementSibling.style.top = document.querySelector('#shopify-section-announcement-bar').getBoundingClientRect().height + document.querySelector('div.Header_inner').getBoundingClientRect().height + 'px';
}
window.onscroll=()=>{
  if (window.pageYOffset > 1){
    document.querySelector('button.burger+nav').classList.add('top');
  } else {
    document.querySelector('button.burger+nav').classList.remove('top');
  }
}
document.querySelector('div#atcpopup>a').onclick=e=>{
  if (document.querySelector('div#cart-drawer')){
    e.preventDefault();
    document.documentElement.classList.add('cart-drawer');
    document.querySelector('div#atcpopup').removeAttribute('style');
  }
}